<footer>
  <div class="flex flex-column align-items-center gap-4 md:gap-3 sm:gap-3 mx-0 p-3 sm:p-4 border-top-1 border-slate-300">
    <div class="flex flex-column align-items-center gap-3">
      <div class="flex gap-3 sm:gap-4">
        <a class="flex align-items-center gap-1 text-sm text-blue-700 cursor-pointer footer-nav-link" (click)="gaIntegration(disclosureLinkLabel)"
          [class.font-medium]="isDisclosureVisible" (click)="isDisclosureVisible = !isDisclosureVisible" tabindex="0" (keydown.enter)="isDisclosureVisible = !isDisclosureVisible">
          Disclosures
          <i class="pi pi-chevron-down no-underline" *ngIf="!isDisclosureVisible"></i>
          <i class="pi pi-chevron-up no-underline" *ngIf="isDisclosureVisible"></i>
        </a>
        <ng-container *ngIf="isThirdPartyVendor">
          <a (click)="gaIntegration(privacyPolicyLinkLabel); navigateThirdpartyVendor('privacy-policy')" (keydown.enter)="gaIntegration(privacyPolicyLinkLabel); navigateThirdpartyVendor('privacy-policy')" class="text-sm text-blue-700 no-underline footer-nav-link cursor-pointer">{{footerLinks.privacyPolicy.name}}</a>
          <a (click)="navigateThirdpartyVendor('terms-of-use'); gaIntegration(termsLinkLabel)" (keydown.enter)="gaIntegration(termsLinkLabel); navigateThirdpartyVendor('terms-of-use')" class="text-sm text-blue-700 no-underline footer-nav-link cursor-pointer">{{footerLinks.termsOfUse.name}}</a>
          <a [href]="footerLinks.doNotSell.url" target="_blank" rel="noopener noreferrer"
            class="text-sm text-blue-700 no-underline footer-nav-link hidden md:inline lg:inline xl:inline" (click)="gaIntegration(doNotSellLink)">{{footerLinks.doNotSell.name}}</a>
        </ng-container>
        <ng-container *ngIf="!isThirdPartyVendor">
          <a [href]="footerLinks.privacyPolicy.url" target="_blank" rel="noopener noreferrer"
            class="text-sm text-blue-700 no-underline footer-nav-link" (click)="gaIntegration(privacyPolicyLinkLabel)">{{footerLinks.privacyPolicy.name}}</a>
          <a [href]="footerLinks.termsOfUse.url" target="_blank" rel="noopener noreferrer"
            class="text-sm text-blue-700 no-underline footer-nav-link" (click)="gaIntegration(termsLinkLabel)">{{footerLinks.termsOfUse.name}}</a>
            <a [href]="footerLinks.doNotSell.url" target="_blank" rel="noopener noreferrer"
              class="text-sm text-blue-700 no-underline footer-nav-link hidden md:inline lg:inline xl:inline" (click)="gaIntegration(doNotSellLink)">{{footerLinks.doNotSell.name}}</a>
        </ng-container>
      </div>
      <div *ngIf="isDisclosureVisible" id="disclosureContent">
        <p class="text-center text-sm text-slate-600 line-height-2 font-normal my-0">
          {{ disclosureContent }}
          <ng-container *ngIf="isThirdPartyVendor">
            <a (click)="navigateThirdpartyVendor('disclosure')" class="text-sm text-blue-700 font-normal cursor-pointer">View&nbsp;more</a>
          </ng-container>
          <ng-container *ngIf="!isThirdPartyVendor">
            <a [href]="footerLinks.disclosures.url" class="text-sm text-blue-700 font-normal" target="_blank"
              rel="noopener noreferrer">View&nbsp;more</a>
          </ng-container>
        </p>
      </div>
    </div>
    <p class="text-sm text-slate-600 line-height-2 my-0 block md:hidden lg:hidden xl:hidden">
      <a [href]="footerLinks.doNotSell.url" target="_blank" rel="noopener noreferrer"
        class="text-sm text-blue-700 no-underline footer-nav-link"
        (click)="gaIntegration(doNotSellLink)">{{footerLinks.doNotSell.name}}</a>
    </p>
    <div *ngIf="socialLinksContentLinks && socialLinksContentLinks.length" class="flex md:gap-6 gap-4">
      <a *ngFor="let link of socialLinksContentLinks[0].linkLabels; let i = index; trackBy: trackByIndex" [href]="link.linkUrl" target="_blank"
        rel="noopener noreferrer" class="flex gap-2 sm:gap-3 text-blue-900 no-underline text-sm footer-nav-link"
        [attr.aria-label]="link.linkLabel" (click)="gaIntegration(link.linkLabel)">
        <i class="text-2xl text-slate-600" [ngClass]="iconClassesMap[link.linkLabel]"></i>
      </a>
    </div>
    <p class="text-sm text-slate-600 line-height-2 my-0">&copy;{{currYear}} Cinch Home Services, Inc. All rights
      reserved.</p>
  </div>
</footer>